define([
    'jquery',
    './helpers/console',
    './vendor/jquery.cookie'
], function ($, console) {
    'use strict';

    var init = function() {
        if ($.cookie('cookies_accepted') === undefined) {
            $('.block_cookie_policy').addClass('visible');
        } else {
            $('.block_cookie_policy').removeClass('visible');
        }

        $('.js-cookie-btn-close').on('click', function (event) {
            event.preventDefault();
            $('.block_cookie_policy').removeClass('visible');
            $.cookie('cookies_accepted', '1', {'expires': 365, 'path': '/'});
        });
    };

    return {
        init: init
    };
});
